import { render, staticRenderFns } from "./ApplicantsList.vue?vue&type=template&id=602f67df&scoped=true"
import script from "./ApplicantsList.vue?vue&type=script&lang=js"
export * from "./ApplicantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f67df",
  null
  
)

export default component.exports